import clean from "../../../assets/Services_img/cleaning.jpg";

export const sensorCleaningCalibrationService = {
  hero: {
    title: "Sensor Cleaning, Calibration & ",
    description:
      "Ensuring precise oxygen and moisture measurement for reliable glovebox operation.",
      title2:"Validation",
      imgUrl:clean
  },

  productsDetails: {
    imgList: [
      clean
    ],

    productName: "Sensor Cleaning, Calibration & Validation",

    description:
      "This service ensures accurate and reliable monitoring of oxygen and moisture levels inside glovebox systems. Our technicians perform professional cleaning, calibration, and functional validation of O₂ and H₂O analyzers to maintain precise atmosphere control and compliance with research and industrial standards.",

    keyFeatures: [
      "Oxygen (O₂) sensor cleaning and calibration",
      "Moisture (H₂O) analyzer servicing",
      "Calibration using certified reference standards",
      "Functional validation and performance verification",
      "Compatibility with OEM and custom glovebox sensors",
    ],

    download: {
      title: "Download Service Overview PDF",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Service Description",

    briefDescirption:
      "Accurate atmosphere sensing is critical for protecting air-sensitive materials and ensuring process reliability. Regular sensor cleaning, calibration, and validation minimizes measurement drift, improves system confidence, and supports consistent glovebox performance over time.",
  },
};
